import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import ItemPropertyEditContainer from './ItemPropertyEditContainer';
import { Grid, Dialog, DialogContent, DialogActions, DialogTitle } from '@mui/material';
import { IconButton } from '@totalsoft/rocket-ui';
import FlexBox from 'components/common/FlexBox';
import { editItemPropertyVar } from 'features/items/edit/variables';
import { useTranslation } from 'react-i18next';
import { useReactiveVar } from '@apollo/client';

const ItemPropertyModalComponent = ({ itemProperties }) => {
  const { t } = useTranslation();
  const editItemProperty = useReactiveVar(editItemPropertyVar);

  const handleClose = useCallback(() => {
    editItemPropertyVar({ open: false });
  }, []);

  return (
    <Dialog
      id={`item_${editItemProperty?.property?.itemId}_property_${editItemProperty?.property?.propertyId}`}
      open={editItemProperty.open}
      fullWidth
      maxWidth='xl'
      TransitionProps={{ exit: false }}
    >
      <Grid container sx={{ p: 1 }}>
        <DialogTitle color='primary' fontWeight='bold' variant='subtitle1'>
          {editItemProperty?.property?.propertyId ? t('Items.Properties.EditProperty') : t('Items.Properties.AddProperty')}
        </DialogTitle>
        <FlexBox grow={1} justifyContent='end'>
          <DialogActions>
            <Grid />
            <IconButton color='primary' variant='text' tooltip={t('Close')} size='tiny' type='cancel' onClick={handleClose} />
          </DialogActions>
        </FlexBox>
      </Grid>
      <DialogContent sx={{ paddingTop: 0 }}>
        <ItemPropertyEditContainer itemProperties={itemProperties} />
      </DialogContent>
    </Dialog>
  );
};

ItemPropertyModalComponent.propTypes = {
  itemProperties: PropTypes.array
};

export default ItemPropertyModalComponent;
